import styled from 'styled-components';
import Card from '../../components/ui/Card';

export const TituloSeccion = styled.h1`
  font-size: 1.7rem;
  color: ${({ theme }) => theme.colors.sageDeep};
  margin-bottom: ${({ theme }) => theme.space.lg};
`;

export const BarraAcciones = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.sm};
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space.lg};
`;

export const TablaEnvoltura = styled(Card)`
  padding: 0;
  overflow-x: auto;
`;

export const Tabla = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
  min-width: 640px;

  th {
    text-align: left;
    padding: 0.8rem 1rem;
    background: ${({ theme }) => theme.colors.sand};
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    white-space: nowrap;
  }

  td {
    padding: 0.75rem 1rem;
    border-top: 1px solid ${({ theme }) => theme.colors.border};
    vertical-align: middle;
  }

  tr:hover td {
    background: ${({ theme }) => theme.colors.bg};
  }
`;

export const CeldaAcciones = styled.td`
  display: flex;
  gap: ${({ theme }) => theme.space.xs};
  justify-content: flex-end;
`;

export const SinDatos = styled.p`
  padding: ${({ theme }) => theme.space.xl};
  text-align: center;
  color: ${({ theme }) => theme.colors.textMuted};
`;
